import React from 'react';
import GamificationServices from '../services/GamificationServices';

const XPStatsCard = ({ profile }) => {
  if (!profile) {
    return (
      <div className="gamification-card">
        <div className="card-header">
          <h3 className="card-title">
            <i className="las la-star"></i>
            Estatísticas XP
          </h3>
        </div>
        <div className="loading-container" style={{ padding: '2rem' }}>
          <div className="loading-text">Carregando...</div>
        </div>
      </div>
    );
  }

  const { current_xp, total_xp_earned, last_level_up } = profile;

  const formatLastLevelUp = (dateString) => {
    if (!dateString) return 'Nunca';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return 'Hoje';
    if (diffDays === 2) return 'Ontem';
    if (diffDays <= 7) return `${diffDays - 1} dias atrás`;
    if (diffDays <= 30) return `${Math.ceil((diffDays - 1) / 7)} semanas atrás`;
    return `${Math.ceil((diffDays - 1) / 30)} meses atrás`;
  };

  return (
    <div className="gamification-card">
      <div className="card-header">
        <h3 className="card-title">
          <i className="las la-star"></i>
          Estatísticas XP
        </h3>
        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
          Experience Points
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-item">
          <div className="stat-value" style={{ color: 'var(--primary)' }}>
            {GamificationServices.formatXP(current_xp || 0)}
          </div>
          <div className="stat-label">XP Atual</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-value" style={{ color: 'var(--success)' }}>
            {GamificationServices.formatXP(total_xp_earned || 0)}
          </div>
          <div className="stat-label">XP Total</div>
        </div>
      </div>

      {last_level_up && (
        <div style={{ 
          textAlign: 'center', 
          marginTop: '1rem', 
          padding: '0.75rem', 
          background: 'var(--success-50)', 
          borderRadius: '8px',
          border: '1px solid var(--success-100)'
        }}>
          <div style={{ fontSize: '0.8rem', color: 'var(--success)', marginBottom: '0.25rem' }}>
            <i className="las la-arrow-up"></i> Último Level Up
          </div>
          <div style={{ fontSize: '0.9rem', fontWeight: '600', color: 'var(--success)' }}>
            {formatLastLevelUp(last_level_up)}
          </div>
        </div>
      )}

      <div style={{ marginTop: '1rem' }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '0.5rem', 
          fontSize: '0.8rem', 
          color: 'var(--text-muted)',
          marginBottom: '0.5rem'
        }}>
          <i className="las la-info-circle"></i>
          <span>Ganhe XP completando atividades na plataforma</span>
        </div>
        
        <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', lineHeight: '1.3' }}>
          • Treinamentos: 10-50 XP<br />
          • Agentes: 100 XP<br />
          • Marketplace: 200+ XP<br />
          • Conquistas: 50-5000 XP
        </div>
      </div>
    </div>
  );
};

export default XPStatsCard;